import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   isAuthenticated: false,
//   user: {},
// };
const initialState = {
  isAuthenticated: Boolean(JSON.parse(sessionStorage.getItem("loggedInUser"))),
  isSkipLogin: Boolean(JSON.parse(sessionStorage.getItem("loggedInUser"))?.isSkipLogin),
  user: JSON.parse(sessionStorage.getItem("loggedInUser")) || {},
};


export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      sessionStorage.clear();
      return Object.assign({}, state, {
        isAuthenticated: false,
        user: null,
      });
    },

    setTokens: (_, action) => {
      const { access_token, refresh_token } = action.payload;
      sessionStorage.setItem("access_token", access_token);
      sessionStorage.setItem("refresh_token", refresh_token);
    },
    removeTokens: () => {
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("refresh_token");
    },
    setUserData: (state, action) => {
      sessionStorage.setItem("loggedInUser", JSON.stringify(action.payload));
      state = {
        isAuthenticated: true,
        user: action.payload,
        isSkipLogin: action?.payload?.isSkipLogin || false,
      };
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserData, logout, setTokens, removeTokens } =
  authSlice.actions;

export default authSlice.reducer;
